import { createAction } from '@reduxjs/toolkit';

export const duplicate = createAction('[Duplicate] duplicate');
export const updateLoading = createAction('[Duplicate] updateLoad');
export const complete = createAction('[Duplicate] complete');
export const error = createAction('[Duplicate] error');
export const closeErrorModal = createAction('[Duplicate] closeErrorModal');
